import React, {useEffect, useRef, useState} from "react";
import {Row, Col, Container, Button} from 'reactstrap';
import {useNavigate, useParams} from 'react-router-dom';
import token from '../AuthToken';
import Config from "../Config";
import _ from "../Trans";


export default function Promo() {
    const [applyingCode, setApplyingCode] = useState(true);
    const [appliedSuccessfully, setAppliedSuccessfully] = useState(false);
    const [alreadyApplied, setAlreadyApplied] = useState(false);
    const [amount, setAmount] = useState(null);
    const [errorMessage, setErrorMessage] = useState(_('Promo already applied'));
    let code = useParams();
    let currentCode = useRef(null);
    let locked = useRef(false);

    const applyCode = function () {
        if(locked.current) {
            return;
        }
        locked.current = true;
        setApplyingCode(true);
        setAlreadyApplied(false);
        setAppliedSuccessfully(false);
        setErrorMessage(_('Promo already applied'));
        let data = {
            'code': code
        }
        fetch(Config.promoUrl.replace("PROMOCODE", code.promocode), {
            method: 'POST',
            headers: {
                Authorization: 'Token '+token,
            },
            data: data
        })
        .then(function(e) {
            if(e.status < 300) {
                return Promise.resolve(e.json())
            }
            let error = {
                code: e.status
            }
            Object.assign(error, e.json())
            return Promise.reject(error)
        })
        .then((e) => setAmount(e.amount))
        .then(() => setAppliedSuccessfully(true))
        .catch(
            (e) => {
                setAlreadyApplied(true);
                setAppliedSuccessfully(false);
                if (e.code === 404) {
                    setErrorMessage(_("Promo code not found"))
                }
                else if(e.code === 500) {
                    setErrorMessage(_("Error applying promo"))
                }
                console.error("Error applying promocode", e);
            }
        )
        .finally(() => {
            setApplyingCode(false)
            locked.current = false;
        });
    }

    useEffect(() => {
        if(code && code.promocode !== currentCode.current && !locked.current) {
            currentCode.current = code.promocode;
            applyCode();
        }
    }, [code]);  // eslint-disable-line

    return (
        <Container className="mt-4 promo-container center mb-5 pb-5 mt-4 pt-5" style={{marginLeft: 0, marginRight: 0, paddingLeft: 0, paddingRight: 0, width: "100%", maxWidth: "unset"}}>
            {code.promocode &&
            <Row style={{color: 'black'}} className={"h2"}>
                <Col sm={12} className={"text-center"}>
                    {applyingCode &&  _('Applying promo code')}
                    {
                        appliedSuccessfully &&
                        <>
                        {_('Promo applied')}<br/>
                        {_('Your budget has been increased in')} {amount} €
                        </>
                    }
                    {!applyingCode && alreadyApplied && !appliedSuccessfully && errorMessage}
                </Col>
            </Row>
            }
            {!code.promocode &&
                <CodeInput/>
            }
        </Container>
    )
}

function CodeInput() {
    const [code, setCode] = useState("");
    const navigate = useNavigate();

    const handleInputChange = (e) => {
        setCode(e.target.value);
    };

    const handleButtonClick = () => {
        if (code.trim() !== "") {
            navigate(`/promo/${code.toUpperCase()}/`);
        } else {
            alert(_("Please enter a valid code"));
        }
    };

    return (
        <Row style={{ color: "black" }} className={"h2"}>
            <Col sm={12} className={"text-center"}>
                {_("Promo code")}
            </Col>
            <Col sm={12} md={{size: 6, offset: 3}} lgO className={"text-center"}>
                <div className="d-flex justify-content-center w-100">
                    <input
                        id="promo-code"
                        type="text"
                        className="form-control mt-0"
                        placeholder={"Enter your code"}
                        value={code}
                        onChange={handleInputChange}
                    />
                    <Button color="primary" onClick={handleButtonClick}>
                        {_("Submit")}
                    </Button>
                </div>
            </Col>
        </Row>
    );
}